import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("title",function(){return [_c('vAlertHeader',{attrs:{"title":"OR Pay with PayFast","color":"red"}})]}),_c(VImg,{staticClass:"block justify-center mb-6",attrs:{"src":"images/payments/instant-eft.png","width":"100%"}}),_c('form',{ref:"PayFastPayNowForm"},[_c('button',{staticClass:"block justify-center",attrs:{"type":"submit"}},[_vm._v(" Pay "+_vm._s(_vm.formatMoney(Number(_vm.plan.price)))+" ")])]),_c('div',{ref:"formSpace"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }